// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2q0E3","title":"styles_title__2QHju"};